import { RcFile, UploadFile } from 'antd/lib/upload/interface'
import { getAcceptFormats } from '../../../utils/getAcceptFormat'
import uniqueKey from '../../../utils/uniqueKey'

export type UploadFormat = 'file' | 'image' | 'video' | 'all'

export const createUploadFiles = (files: File[]): UploadFile[] =>
  files.map((file) => {
    const uid = uniqueKey()
    const originFileObj = file as RcFile
    originFileObj.uid = uid
    return { uid, name: file.name, size: file.size, type: file.type, originFileObj }
  })

export const validateUploadFiles = (
  fileList: UploadFile[],
  options: { formatFiles?: UploadFormat; withoutVideo?: boolean; maxFiles?: number } = {},
) => {
  const matches = (file: UploadFile, format: UploadFormat) =>
    getAcceptFormats(format)
      .split(',')
      .some((extension) => file.name.toLowerCase().endsWith(extension))
  let hasBigFile = false
  let hasIncorrectFileFormat = false
  const maxFiles = options.maxFiles ?? 10
  const files = fileList.slice(0, maxFiles).filter((file) => {
    const isVideo = matches(file, 'video')
    const isImage = matches(file, 'image')
    const isOtherFile = matches(file, 'file')
    const correctFormat =
      options.formatFiles === 'file'
        ? isOtherFile
        : options.formatFiles === 'image'
        ? isImage
        : isVideo || isImage || isOtherFile
    if (!correctFormat) {
      hasIncorrectFileFormat = true
      return false
    }
    if ((file.size || 0) > (isVideo ? 500 : 100) * 1024 * 1024) {
      hasBigFile = true
      return false
    }
    return true
  })
  const warnings: string[] = []
  if (fileList.length > maxFiles) warnings.push(`Максимальное число файлов не должно быть больше ${maxFiles}`)
  if (hasBigFile)
    warnings.push(
      options.withoutVideo
        ? 'Максимально допустимый размер файла 100 Мбайт'
        : 'Максимально допустимый размер файла для видео 500 Мбайт, для прочих 100 Мбайт',
    )
  if (hasIncorrectFileFormat) warnings.push('Недопустимый формат файла')
  return { files, warnings }
}
